import config from "src/config";
import { ResponseDto } from "src/dtos/common/responseDto";
import {
	deleteDataList,
	getData,
	postData,
} from "src/utils/axios/serverHelper";
import { formatDate } from "src/utils/string/stringUtil";

import {
	KSK2140_R01DetailDto,
	KSK2140_R01Dto,
	KSK2140_R01HeaderDto,
	KSK2140_R01InspectDto,
	KSK2140_R01WorkStandardDto,
} from "./Dto_KSK2140_R01";
import { KSK2140_R01Filter } from "./Store_KSK2140_R01";

const baseUrl = `${config.apiUrl}/KSK2140_R01`;

export const getKSK2140_R01WorkStandardOne = (itemCd: string, sheetNo: 1 | 2) => {
	return getData<ResponseDto<KSK2140_R01WorkStandardDto | null>>(
		`${baseUrl}/workStandard/${encodeURIComponent(itemCd)}/${sheetNo}`,
	);
};

/** WHERE 조건 값이 있을 때만 파라미터 전송 */
const getKSK2140_R01Params = (filter: Partial<KSK2140_R01Filter>) => {
	const params: Record<string, string> = {};

	if (filter.compCd) {
		params.compCd = filter.compCd;
	}
	if (filter.dateRange?.from && filter.dateRange?.to) {
		params.startDate = formatDate(filter.dateRange.from);
		params.endDate = formatDate(filter.dateRange.to);
	}
	if (filter.workplaceCd) {
		params.workplaceCd = filter.workplaceCd;
	}
	if (filter.orderEmp) {
		params.orderEmp = filter.orderEmp;
	}

	return params;
};

export const getKSK2140_R01List = (option: string, filter: Partial<KSK2140_R01Filter>) => {
	return getData<ResponseDto<KSK2140_R01HeaderDto[]>>(`${baseUrl}/${option}`, { params: getKSK2140_R01Params(filter) });
};

export const getKSK2140_R01DetailList = (productOrderNo: string) => {
	return getData<ResponseDto<KSK2140_R01DetailDto[]>>(`${baseUrl}/detail/${productOrderNo}`);
};

export const getKSK2140_R01LotList = (productOrderNo: string) => {
	return getData<ResponseDto<KSK2140_R01DetailDto[]>>(`${baseUrl}/lot`, { params: { productOrderNo } });
};

export const createKSK2140_R01LotNo = async () => {
	return await getData<ResponseDto<string>>(`${baseUrl}/lot/createLotNo`);
};

export const getKSK2140_R01InspectList = (productOrderNo: string) => {
	return getData<ResponseDto<KSK2140_R01InspectDto[]>>(`${baseUrl}/inspect`, { params: { productOrderNo } });
};

export const postKSK2140_R01 = (data: KSK2140_R01Dto) => {
	return postData<KSK2140_R01Dto, ResponseDto<KSK2140_R01Dto>>(`${baseUrl}`, data);
};

export const deleteKSK2140_R01 = (data: KSK2140_R01DetailDto[]) => {
	return deleteDataList<KSK2140_R01DetailDto[], ResponseDto<void>>(`${baseUrl}/detail`, data);
};
